import { memo, useEffect, useRef, useState } from "react"
import "./Chips.css"
const Chips = memo(({ gameChips, selectedChipIndex, chipSelectionFn = () => { }, isMobile, containerClassName = "chipContainer", chipWidth = "150px", chipHeight = "150px" }) => {

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        // Cleanup to prevent memory leaks
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const chips = useRef([
        {
            value: 1,
            color: "black",
            fontSize: "50px"
        },
        {
            value: 5,
            color: "#8B4513",
            fontSize: "50px"
        },
        {
            value: 10,
            color: "brown",
            fontSize: "50px"
        },
        {
            value: 20,
            color: "blue",
            fontSize: "50px"
        },
        {
            value: 25,
            color: "green",
            fontSize: "50px"
        },
        {
            value: 50,
            color: "#ff002d",
            fontSize: "50px"
        },
        {
            value: 75,
            color: "#00b3e0ff",
            fontSize: "50px"
        },
        {
            value: 100,
            color: "orange",
            fontSize: "50px"
        },
        {
            value: 200,
            color: "purple",
            fontSize: "50px"
        },
        {
            value: 250,
            color: "red",
            fontSize: "50px"
        },
        {
            value: 500,
            color: "#00b5ff",
            fontSize: "50px"
        },
        {
            value: "1K",
            color: "#5300ff",
            fontSize: "50px"
        },
        {
            value: "5K",
            color: "black",
            fontSize: "50px"
        },
        {
            value: "10k",
            color: "black",
            fontSize: "50px"
        }
    ])

    const convertBetValue = (chngAmt) => {
        let newAmt = Number((chngAmt));
        if (newAmt >= 1000 && newAmt <= 999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "K";
        } else if (newAmt >= 1000000 && newAmt <= 999999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "M";
        } else if (newAmt > 999999999) {
            newAmt = Number((newAmt / 1000)?.toFixed(2)) + "B";
        }
        return newAmt;
    }

    const cx = 150;
    const cy = 150;
    return <div className={containerClassName}>
        {gameChips?.split(",")?.map((ele, index) => {
            return <div key={JSON.stringify(ele)} className={`chip_svg ${index === ((isMobile || window.innerHeight > window.innerWidth) && (selectedChipIndex > 0 ? selectedChipIndex : 0)) ? "chipSelected" : ""}`} onClick={() => { chipSelectionFn(ele, index) }}>
                <svg
                    width={chipWidth}
                    height={chipHeight}
                    viewBox="0 0 300 300"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Background */}
                    <circle cx={cx} r="135" cy={cy} fill={"#fff"} />
                    {/* <rect width="400" height="400" fill={"#ffffff00"} /> */}

                    {/* Outer segmented ring */}
                    <circle
                        cx={cx}
                        cy={cy}
                        r="135"
                        fill="none"
                        stroke={chips.current[index]?.color}
                        strokeWidth="2"
                    />

                    {/* Middle segmented ring */}
                    <circle
                        cx={cx}
                        cy={cy}
                        r="125"
                        fill="none"
                        stroke={chips.current[index]?.color}
                        strokeWidth="20"
                        strokeDasharray="40 90"
                    />

                    {/* Inner solid ring */}
                    <circle
                        cx={cx}
                        cy={cy}
                        r="110"
                        fill="none"
                        stroke={chips.current[index]?.color}
                        strokeWidth="15"
                    />

                    {/* Center circle */}
                    <circle
                        cx={cx}
                        cy={cy}
                        r="85"
                        fill={"#fff"}
                        stroke={chips.current[index]?.color}
                        strokeWidth="3"
                    />

                    {/* Center Text */}
                    <text
                        x={cx}
                        y={cy}
                        textAnchor="middle"
                        dominantBaseline="central"
                        fill={"#000"}
                        fontSize={String(convertBetValue(ele)).length === 5 ? 50 : String(convertBetValue(ele)).length === 4 ? 60 : 80}
                        fontWeight="bold"
                    >
                        {convertBetValue(ele)}
                    </text>
                </svg>
            </div>
        })}
    </div>

    // <div className="chipContainer">
    //     {gameChips?.map((ele, index) => {
    //         return <div key={index} className={`chip_outer ${/Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? "androidChip" : ""} ${index === ((window.innerHeight > window.innerWidth) && (selectedChipIndex > 0 ? selectedChipIndex : 0)) ? "chipSelected" : ""}`} style={{ "--chipColor": chips.current[ele].color }} onClick={() => { chipSelectionFn(ele, index) }}>
    //             <div className="innerCircle" style={{ "--chipColor": chips.current[ele].color }}>
    //                 <div className="chipvalContent" style={{ "--fontSize": chips.current[ele].fontSize }}>{chips.current[ele].value}</div>
    //             </div>
    //         </div>
    //     })}
    // </div>
})

export default Chips